import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { useObserve } from '@/libs/state'
import { makeSetTheme } from '../application/set-theme'
import { themePort } from '../wiring'
import { theme$ } from '../store'

type Props = { children: ReactNode }

const setTheme = makeSetTheme(themePort)

const ThemeProvider = ({ children }: Props) => {
	useEffect(() => {
		const media = window.matchMedia('(prefers-color-scheme: dark)')

		const onSystemChange = () => {
			if (theme$.get() === 'system') setTheme('system')
		}

		media.addEventListener('change', onSystemChange)
		return () => media.removeEventListener('change', onSystemChange)
	}, [])

	useObserve(() => {
		setTheme(theme$.get())
	})

	return <>{children}</>
}

export { ThemeProvider }
